
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company-slug]/blog",
      function () {
        return require("private-next-pages/[company-slug]/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company-slug]/blog"])
      });
    }
  